<template>
    <div class="live-header" :style="bgStyle">
        <header class="header">
            <div class="header-left">
                <img src="@/assets/img/live/logo.png" class="logo">
                <ul class="left-nav">
                    <li :class="[['/index'].includes(currPath) ? 'active' : '']" @click="goTo('/index')">首页</li>
                    <li :class="[['/video','/stream'].includes(currPath) ? 'active' : '']" @click="goTo('/stream')">直播</li>
                    <!-- <li :class="[['/user'].indexOf(currPath) ? 'active' : '']" @click="goTo('/user')">个人中心</li> -->
                </ul>
            </div>
            <div class="header-right">
                <div class="search">
                    <Input v-model="keyword" placeholder="" class="search-input" maxlength="15"
                        style="display: none;">
                        <template #suffix>
                            <Icon type="ios-search" size="20"/>
                        </template>
                    </Input>
                </div>
                <div class="userinfo">
                    <div class="info-item" @click="$login.showLogin()" v-if="!isLogin">
                        <Icon type="ios-contact-outline" size="20"/>
                        <p>登录</p>
                    </div>
                    <!-- <div class="info-item" v-if="isLogin">
                        <Icon type="ios-notifications" size="20"/>
                        <p>消息</p>
                    </div> -->
                    <div class="info-item-avatar" v-if="isLogin">
                        <template v-if="!wcnCfg">
                            <Dropdown @on-click="handelDropMenu">
                                <img :src="user.avatar" class="user-avatar">
                                <DropdownMenu slot="list">
                                    <DropdownItem name="chonzhi">在线充值</DropdownItem>
                                    <DropdownItem name="user">个人中心</DropdownItem>
                                    <DropdownItem name="logout">退出登录</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </template>
                        <template v-else>
                            <img :src="user.avatar" class="user-avatar">
                        </template>
                    </div>
                    <span v-if="isLogin" style="margin:-5px 0 0 20px; cursor: pointer;" @click="wcnAction">未成年保护<p style="font-size:10px;margin:1px 0 0 0;" :class="[!wcnCfg ? 't-red' : 't-green']">{{ !wcnCfg ? '未开启' : '已开启' }}</p></span>
                </div>
            </div>
        </header>

        <!-- 未成年 未配置时、显示配置 -->
        <setA ref="setARef"/>
        <!-- 未成年 已配置时、显示清空配置 -->
        <setC ref="setCRef"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {
    logoutApi, //退出登录
} from '@/api/apis/liveHome.js';
import setA from '@/components/wcn/setA.vue'; //未成年 未配置时、显示配置
import setC from '@/components/wcn/setC.vue'; //未成年 已配置时、显示清空配置
export default {
    name: "LiveHeader",
    components: {
        setA, setC
    },
    data() {
        return {
            keyword: ''
        };
    },
    computed: {
		...mapState(['user', 'isLogin', 'wcnCfg']),
        bgStyle() {
            let that = this, currPath = that.$router.currentRoute.path, styleObj = {};
            if (currPath != '/index') {
                styleObj = { backgroundColor: '#101A1D', color: '#ffffff' };
            }
            //styleObj = { backgroundColor: '#101A1D', color: '#ffffff' };
            return styleObj;
        },
        currPath() {
            return this.$router.currentRoute.path;
        }
    },
    mounted() {
    },
    methods: {
        //未成年保护模式
        wcnAction(){
            if(!this.wcnCfg){ //未配置时、显示配置
                this.$refs.setARef.show();
            }else{ //已配置时、显示清空配置
                this.$refs.setCRef.show();
            }
        },
        //连接跳转
        goTo(path){
            this.$router.push({ path: path }).then(() => {
                window.location.reload();
            });
        },
        //下拉菜单
        handelDropMenu(name){
            //退出登录
            if(name == 'logout'){
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定要退出登录吗？',
                    onOk: () => {
                        logoutApi().then(res => {
                            this.$store.commit('setLogout')
                            this.$Message.success('您已退出登录');
                        });
                    },
                    onCancel: () => { }
                })
            }
            //个人中心跳转
            if(name == 'user'){
                this.goTo('/user')
            }
            //显示充值弹窗
            if(name == 'chonzhi'){
                this.$chongZhi.showChongZhi()
            }
            return
        }
    }
};
</script>

<style lang="scss" scoped>
.live-header{
    .t-red {
        color: #E20114;
    }
    .t-green{
        color: #27b110;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/live/LiveHeader.vue